// extracted by mini-css-extract-plugin
module.exports = {"medHead":"Rules_medHead__2ids6","text":"Rules_text__3WUmE","list":"Rules_list__3sq6T"};